import React, { useState, useRef } from 'react';
import { useReactFlow } from '@xyflow/react';
import { useAccomodationDiagram } from '../AccomodationDiagramContext';
import { EventDataDialog } from '../dialog/EventDataDialog';
import { ColorPicker } from '../../../../components/ColorPicker';

export default function EventContextMenu({
  id,
  top,
  left,
  right,
  bottom,
  onPaneClick,
  ...props
}) {
  const { getNode } = useReactFlow();
  const node = getNode(id);
  const { updateNodesF, setShowComments, nodes } = useAccomodationDiagram();
  const [selectedColor, setSelectedColor] = useState('#ffffff'); // Domyślny kolor
  const [openEventDataDialog, setOpenEventDataDialog] = React.useState(false);

  const handleColorChange = color => {
    const newColor = color.hex; // Nowy kolor z inputu
    setSelectedColor(newColor); // Ustaw nowy kolor
    const updatedNodes = [];
    const node = getNode(id);
    const sameEventNodes = nodes.filter(n => n.type == 'EventNode' && n.data.eventId == node.data.eventId);
    sameEventNodes.map(n => {
      const updatedNode = {
        ...n,
        style: {
          ...n.style,
          backgroundColor: newColor // Zastosuj nowy kolor
        }
      };
      updatedNodes.push(updatedNode);
    });
    updateNodesF(updatedNodes);
    // onPaneClick();
  };

  const handleAddPrefix = () => {
    setOpenEventDataDialog(true);
  };

  return (
    <div
      style={{ top, left, right, bottom }}
      className="context-menu"
      {...props}
    >
      {/* <ColorPicker color={selectedColor} handleColorChange={handleColorChange} /> */}
      <button onClick={handleAddPrefix}>
        Edytuj dane imprezy
      </button>
      <button onClick={() => setShowComments(true)}>Pokaż komentarze</button>
      {openEventDataDialog && <EventDataDialog open={openEventDataDialog} setOpen={setOpenEventDataDialog} eventNode={node} />}
    </div>
  );
}
